import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-status-header-modal',
  templateUrl: './status-header-modal.component.html',
  styleUrls: ['./status-header-modal.component.scss']
})
export class StatusHeaderModalComponent implements OnInit {

  @Input() icon;
  @Input() status;
  @Input() color;

  constructor() { }

  ngOnInit(): void {
  }

}
